import React, { useEffect,useState } from "react";
import Intro from "./Intro";
import PricingCard from "./Pricing-card";

import { fetchCheckout } from "../../../states/actions/fetchCheckout";
import { useSelector, useDispatch } from "react-redux";
import useDocumentTitle from "../../../hooks/useDocumentTitle";
import LoadingScreen from "../../common/LoadingScreen";
import ImageControl from "../../common/ImageControl";
import { useParams } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { ToastContainer } from "react-toastify";
import { format_amount } from '../../../helpers/helpers';
import MetaGenerator from "../../common/meta-generator";

// Module-level fire-once guard, keyed by the request shape (plan + enterprise
// flag + invite id). Survives component remounts — which matters because
// App.jsx defines its layout components (PublicEnterPriseLayout etc.) as
// closures inside the App function. Every App re-render produces a new
// function identity, which React Router treats as a new component type and
// remounts this subtree. Without this guard, each remount re-fires the
// effect below, which re-calls fetchCheckout, which on a status:1 response
// dispatches fetchSiteSettings — which triggers another App re-render → another
// remount → another fetchCheckout. The backend mints a fresh authToken on
// every call so the loop wouldn't naturally settle (272 calls/min observed).
const dispatchedCheckoutKeys = new Set();

const Checkout = ({enterprise=false}) => {

  
  const { plan_id } = useParams();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.fetchCheckout.content);
  const isLoading = useSelector((state) => state.fetchCheckout.isLoading);
  const isSiteSettingsLoading = useSelector(
    (state) => state.fetchSiteSettings.isLoading
  );
  // console.log(data?.plan)
  const { content, plan, terms_conditions, subscription_agreement, meta } = data;
  const site_settings = useSelector(
    (state) => state.fetchSiteSettings.site_settings
  );
  const subscription = site_settings?.member?.mem_subscription;
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const userEncodedId = queryParams.get("user_encoded_id");
    const key = `${plan_id}|${enterprise ? 1 : 0}|${userEncodedId || ""}`;
    if (dispatchedCheckoutKeys.has(key)) return;
    dispatchedCheckoutKeys.add(key);
    dispatch(
      fetchCheckout({
        plan_id,
        enterprise: enterprise ? 1 : 0,
        user_encoded_id: userEncodedId,
      })
    );
  }, []);

  // useDocumentTitle(data.page_title);
  // Only use the TEST publishable key when a testing user is EXPLICITLY configured
  // AND the logged-in member matches it. Never rely on `email === undefined`: on prod
  // REACT_APP_STRIPE_TESTING_USER is unset, and site-settings may not be loaded yet on a
  // cold page load — the old `mem_email === REACT_APP_STRIPE_TESTING_USER` check then
  // resolved to `undefined === undefined` (true) and loaded the TEST key, so cards were
  // tokenized in the wrong Stripe account and checkout failed with "No such PaymentMethod".
  const stripeTestingUser = process.env.REACT_APP_STRIPE_TESTING_USER;
  const stripeMemberEmail = site_settings?.member?.mem_email;
  const stripePromise = loadStripe(
    stripeTestingUser && stripeMemberEmail && stripeMemberEmail === stripeTestingUser
      ? process.env.REACT_APP_STRIPE_TESTING_KEY
      : process.env.REACT_APP_STRIPE_PUBLIC_KEY
  );
  // Render as soon as our own checkout content is ready. Don't gate on
  // isSiteSettingsLoading — site-settings is fetched independently by
  // App.jsx and is only consumed here for a Stripe testing-key check and
  // to populate the Header. If that call hangs or trips the not_logged
  // redirect mid-load, blocking on it leaves the page stuck on a spinner
  // forever (the symptom that previously required a hard refresh).
  return (
    <>
      {isLoading ? (
        <LoadingScreen />
      ) : (
        <>
          <MetaGenerator page_title={data?.page_title} meta_desc={meta} noindex />
          <Elements stripe={stripePromise}>
            <ToastContainer />
            <section className="logon">
              <div className="contain">
                <div className="flex">
                  <Intro subscription_plan_id={parseInt(subscription?.plan_id)} subscription={subscription} terms_conditions={terms_conditions} subscription_agreement={subscription_agreement} enterprise={enterprise} />
                  <div className="colR self_start pricing_check_out flex price_flex new_price_flex">
                    <PricingCard plan={plan} />
                  </div>
                </div>
              </div>
              <div className="lg_image">
                <ImageControl src={content.image1} folder="images" />
              </div>
            </section>
          </Elements>
        </>
      )}
    </>
  );
};

export default Checkout;
